import { fetchJSON } from "../framework/api";
import { alertInfo, alertError } from "../framework/dialog";
import * as Popup from "../framework/components/popup";
import { getUITranslation } from "../utils/get_ui_translation";

let selectedId;
let alreadySelectedId;
const doubleFactor = "double_factor";
const digitalIdentity = "digital_identity";
const selectedClass = "selected_signing";

document.addEventListener("DOMContentLoaded", function (_event) {
  document.getElementById(doubleFactor)?.addEventListener("click", function (ev) {
    handleModeSelection(ev);
  });

  document.getElementById(digitalIdentity)?.addEventListener("click", function (ev) {
    handleModeSelection(ev);
  });

  alreadySelectedId = document.getElementById("selection_box")?.dataset.selected;

  if ([doubleFactor, digitalIdentity].includes(alreadySelectedId)) {
    document.getElementById(alreadySelectedId)?.classList.add(selectedClass);
    showSuccessZone(alreadySelectedId);
  }
});

/**
 * Apply the 'selected' class to the selected option image and remove the class from the unselected option
 * @param {string} DOM id of the selected option / image
 */
function selectOneOption(selectedOption) {
  const notSelected = selectedOption === doubleFactor ? digitalIdentity : doubleFactor;
  document.getElementById(notSelected).classList.remove(selectedClass);
  document.getElementById(selectedOption).classList.add(selectedClass);
}

/**
 * Asks the user for confirmation and handle data to the ajax caller function
 * @param {event}
 */
async function handleModeSelection(event) {
  selectedId = event.target.id;
  if (selectedId === alreadySelectedId) {
    await alertError(
      getUITranslation("Choix du mode de signature"),
      getUITranslation("Il existe déjà une demande d'émargement avec ce mode de signature, il est impossible de continuer")
    );
  } else {
    let isYes;
    selectOneOption(selectedId);
    if (alreadySelectedId != undefined && alreadySelectedId != "" && selectedId != alreadySelectedId) {
      isYes = await Popup.confirm("#method_change_confirmation");
    } else {
      isYes = await Popup.confirm("#" + selectedId + "_popup");
    }

    if (isYes) {
      updateConsentPageChoice(selectedId);
    } else {
      if (alreadySelectedId != undefined && alreadySelectedId != "") {
        selectOneOption(alreadySelectedId);
      } else {
        document.getElementById(selectedId).classList.remove(selectedClass);
      }
    }
  }
}

/**
 *
 * @param {string} id of the selected consent page
 */
async function updateConsentPageChoice(selectedOption) {
  const guestUriCode = document.getElementById("selection_box").dataset.guestcode;
  hideSuccessZone();
  const body = await fetchJSON(p`/ajax/consent_page_choice/${guestUriCode}`, {
    method: "POST",
    body: {
      consentPage: selectedOption,
    },
  });
  if (body.success) {
    await alertInfo(
      getUITranslation("Choix du mode de signature"),
      getUITranslation(
        "Votre choix de méthode est confirmé, vous allez recevoir un nouvel email d'invitation à la signature électronique."
      )
    );
    showSuccessZone(selectedId);
  } else {
    await alertError(getUITranslation("Erreur"), getUITranslation("Une erreur s'est produite, il est impossible de continuer."));
  }
}

/**
 *  Reveal the zone showing the call was sucessfull
 */
function hideSuccessZone() {
  document.getElementById("invitation_success").setAttribute("hidden", true);
  document.getElementById(doubleFactor + "_success").setAttribute("hidden", true);
  document.getElementById(digitalIdentity + "_success").setAttribute("hidden", true);
}

/**
 * Show the success zone on the page
 * @param {string} method selected - Used to fine tune the success message
 */
function showSuccessZone(method) {
  document.getElementById("invitation_success").removeAttribute("hidden");
  document.getElementById(method + "_success").removeAttribute("hidden");
}
